var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"calendar-day",class:{
    'calendar-day--not-current': !_vm.day.isCurrentMonth,
    'calendar-day--today': _vm.isToday,
    'calendar-day--have-event': _vm.haveEvent
  }},[(_vm.haveEvent)?_c('span',{on:{"click":function($event){$event.preventDefault();return _vm.selectDeadlineToCalendarlist()}}},[_vm._v(_vm._s(_vm.label)),_c('i',[_vm._v(_vm._s(_vm.countEvents))])]):_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8093cef4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarMonthDayItem.vue
// module id = 80
// module chunks = 0